import React from "react";
// import { BiSolidChevronDown } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa";

import "./Scrollbutton.css";

const Scrollbutton = (props) => {
  return (
    <div className="scrollbutton">
      <button className="scrolldown" onClick={props.onClick}>
        {/* {newMessage && <p>New Message</p>} */}
        <FaChevronDown size={15} />
      </button>
    </div>
  );
};

export default Scrollbutton;
